module.exports = __webpack_public_path__ + "assets/img/logo-hd.d7b557a2.png";